<template>
  <v-navigation-drawer
    v-model="navDialog"
    app
    dark
    class="primary darken-2 app-drawer"
  >
    <v-list>
      <div class="app-drawer-brand">
        <v-img
          class="mx-auto"
          max-width="128"
          src="@/assets/img/logo.png"
        ></v-img>
      </div>
      <div class="app-drawer-label">MENU</div>

      <v-list-item-group color="secondary" class="mb-5 px-2">
        <template v-for="(item, i) in items">
          <v-list-item
            v-if="viewPermissions(item.roles)"
            :key="i"
            :to="item.link"
            class="nav-item"
            active-class="nav-active"
            dense
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title small v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { viewPermissions } from '@/utils/roles'

export default {
  data: () => ({
    dialog: false,
    drawer: null,
    items: [
      {
        icon: 'mdi-view-dashboard',
        text: 'Dashboard',
        link: '/dashboard',
        roles: [],
      },
      {
        icon: 'mdi-account-cog',
        text: 'Management',
        link: '/management',
        roles: ['admin'],
      },
      {
        icon: 'mdi-account-hard-hat',
        text: 'Service Providers',
        link: { name: 'ServiceProvider' },
        roles: ['admin'],
      },
      {
        icon: 'mdi-text-box-check-outline',
        text: 'Region Management',
        link: '/regions',
        roles: ['admin'],
      },
      {
        icon: 'mdi-car',
        text: 'Assessment center',
        link: { name: 'AssessmentCenter' },
        roles: [
          'internalAssessor',
          'externalAssessor',
          'technician',
          'claimOfficer',
          'sectionHead',
        ],
      },
      {
        icon: 'mdi-timer-outline',
        text: 'TAT Reports',
        link: '/tat-reports',
        roles: [
          'admin',
          'claimOfficer',
          'internalAssessor',
          'sectionHead',
          'technician',
          'customerService',
        ],
      },
    ],
    navDialog: true,
  }),
  created() {
    this.$root.$on('open-close-nav', () => {
      this.navDialog = !this.navDialog
    })
  },
  methods: {
    viewPermissions,
  },
}
</script>

<style scoped>
/* Sleek gradient drawer */
.app-drawer ::v-deep .v-navigation-drawer__content {
  background: linear-gradient(180deg, #063f83 0%, #022f66 100%);
  scrollbar-width: none;
}
.app-drawer ::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
  width: 0;
}
.app-drawer ::v-deep .v-list {
  background: transparent !important;
}
.app-drawer-brand {
  display: flex;
  justify-content: center;
  padding: 22px 16px 14px;
}
.app-drawer-label {
  color: rgba(255, 255, 255, 0.45);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  padding: 4px 20px 6px;
}
.nav-item {
  border-radius: 8px !important;
  margin: 2px 6px;
  min-height: 38px !important;
  transition: background 0.15s ease;
}
.nav-item::before {
  border-radius: 8px;
}
.nav-item:hover {
  background: rgba(255, 255, 255, 0.06);
}
.nav-item ::v-deep .v-list-item__icon {
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 12px !important;
}
.nav-item ::v-deep .v-list-item__title {
  font-size: 13px;
  font-weight: 500;
}
.nav-active {
  background: rgba(255, 255, 255, 0.12) !important;
  box-shadow: inset 2px 0 0 #f8ab10;
}
.nav-active ::v-deep .v-list-item__title,
.nav-active ::v-deep .v-icon {
  color: #ffffff !important;
  font-weight: 600;
}
</style>
